import { FulfillmentGroupDataSchema } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import * as z from "zod";

export const GroupReplacementSchema = z.object({
  groupId: z.string(),
  replacementGroup: FulfillmentGroupDataSchema,
});

export type GroupReplacement = z.infer<typeof GroupReplacementSchema>;

export const getReplacementGroups = {
  name: "getReplacementGroups" as const,
  input: z.object({ groupIds: z.array(z.string()) }),
  output: z.object({ replacements: z.array(GroupReplacementSchema) }),
};
